import apiClient from '../services/apiClient';

export default {
	namespaced: true,
	state: {
		packages: null,
		totalPackages: null,
		options: {
			pageSize: 20,
			search: '',
			currentPage: 1,
			maxPages: 0,
		}
	},
	getters: {
		packages(state) {
			return state.packages;
		},
		pageSize(state) {
			return state.options.pageSize;
		},
		totalPackages(state) {
			return state.totalPackages;
		},
		search(state) {
			return state.options.search;
		},
		currentPage(state) {
			return state.options.currentPage;
		},
		maxPages(state) {
			return state.options.maxPages;
		},
	},
	mutations: {
		SET_PACKAGES(state, packages) {
			state.packages = packages
		},
		SET_MAX_PAGES(state, maxPages) {
			state.options.maxPages = maxPages;
		},
		SET_PAGE_SIZE(state, pageSize) {
			state.options.currentPage = 1;
			state.options.pageSize = pageSize;
		},
		SET_CURRENT_PAGE(state, currentPage) {
			state.options.currentPage = currentPage;
		},
		SET_SEARCH(state, search) {
			state.options.currentPage = 1;
			state.options.search = search;
		},
		SET_TOTAL_PACKAGES(state, totalPackages) {
			state.totalPackages = totalPackages;
		},
		CLEAR_STORE(state) {
			state.packages = null;
			state.totalPackages = null;
			state.options.search = '';
			state.options.pageSize = 20;
			state.options.currentPage = 1;
			state.options.maxPages = 0;
		}
	},
	actions: {
		async getPackages({commit, state}) {
			const params = {
				pageSize: state.options.pageSize,
				page: state.options.currentPage,
				search: state.options.search,
			};
			await apiClient.get('packages/get', {params}).then(res => {
				commit('SET_PACKAGES', res.data.packages);
				commit('SET_TOTAL_PACKAGES', res.data.totalPackages);
				const maxPages = Math.ceil(res.data.totalPackages / state.options.pageSize);
				commit('SET_MAX_PAGES', maxPages);
			}).catch(err => {
			})
		},
		createPackages({commit}, packagesSubmit) {
			return new Promise((resolve, reject) => {
				apiClient.post('packages/create', packagesSubmit).then(res => {
					resolve()
				}).catch(err => {
					reject()
				})
			});
		},
		deletePackages({commit}, package_id) {
			return new Promise((resolve, reject) => {
				apiClient.delete('packages/delete', {data: {package_id}}).then(res => {
					resolve()
				}).catch(err => {
					reject()
				})
			});

		},
		updatePackages({commit}, packagesUpdate) {
			return new Promise((resolve, reject) => {
				apiClient.put('packages/update', packagesUpdate).then(res => {
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
